import * as XLSX from 'xlsx';

export function exportXLSX(data, type) {
  const worksheet = XLSX.utils.json_to_sheet(data); // Convert JSON to worksheet

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'data');

  XLSX.writeFile(workbook, `data.${type}`);
}

export function exportJPG(id) {
  var a = document.createElement('a');
  a.href = document.getElementById(`${id}`).toDataURL('image/jpg');
  a.download = 'chart.png';
  a.click();
}
